export function filterSeries(series, options = {}) {
  if (!series) return [];

  const { year, ids } = options;

  return series.filter(s => {
    // If year is provided, check it
    const matchesYear = year ? s.year === year : true;

    // If ids are provided, check them
    const matchesIds = ids ? ids.includes(s._id) : true;

    return matchesYear && matchesIds;
  });
}